export default function () {
  return [
    {name: 'Ene', meta: 20, resultado: -1},
    {name: 'Mar', meta: 20.5, resultado: 0},
    {name: 'Abr', meta: 21, resultado: 12},
    {name: 'May', meta: 21.5, resultado: 12.5},
    {name: 'Jun', meta: 22, resultado: 11},
    {name: 'Jul', meta: 22.5, resultado: 10},
    {name: 'Ago', meta: 23, resultado: 12},
    {name: 'Sep', meta: 23.5, resultado: 11},
    {name: 'Oct', meta: 24, resultado: 12},
    {name: 'Nov', meta: 24.5, resultado: 12.5},
    {name: 'Dic', meta: 25, resultado: 11},
  ]
};



// WEBPACK FOOTER //
// ./src/reducers/chart-reducers/lossUtilityReducers.js